export enum SupervisorTypeEnum {
  Direct = 1,
  Temporary = 2,
}
